import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { TeamRoleEntity } from './team-role.entity';
import { TeamEntity } from './team.entity';
import { UserEntity } from './user.entity';

@Index('fk_team__id', ['fkTeamId'], {})
@Index('fk_user__id', ['fkUserId'], {})
@Entity('team_user')
export class TeamUserEntity extends BaseEntity {
	@Column('int', { name: 'fk_team__id', unsigned: true })
	public fkTeamId!: number;

	/**
	 * PD-16309 — the member's role on this team, which is what decides their
	 * coverage of the team's clients.
	 *
	 * NULL means no role, which grants NOTHING — and null is what every
	 * existing membership has, so behaviour is unchanged until a tenant
	 * deliberately assigns a coverage-granting role. Being on a roster is a
	 * grouping for lists and reports, never an access grant.
	 */
	@Column('int', { name: 'fk_team_role__id', nullable: true, unsigned: true })
	public fkTeamRoleId!: number | null;

	@ManyToOne(() => TeamRoleEntity, (teamRole) => teamRole.teamUsers, {
		onDelete: 'SET NULL',
		nullable: true,
	})
	@JoinColumn([{ name: 'fk_team_role__id', referencedColumnName: 'id' }])
	public fkTeamRole!: TeamRoleEntity | null;

	@Column('int', { name: 'fk_user__id', unsigned: true })
	public fkUserId!: number;

	@ManyToOne(() => TeamEntity, (team) => team.teamUsers, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: 'fk_team__id', referencedColumnName: 'id' }])
	public fkTeam!: TeamEntity;

	@ManyToOne(() => UserEntity, (user) => user.teamUsers, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: 'fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity;
}
